<template>
  <div
    :class="{
      breadcrumbs: true,
      'breadcrumbs-dark': dark,
      'breadcrumbs-light': !dark,
    }"
    :style="{ '--primary-btn': dark ? '#0084ff' : '#ffffff' }"
  >
    <ul :class="{ 'game-ul': templateName && gameBlockTitle != '' }">
      <li v-for="(data, index) in breadcrumbData" :key="index">
        <template v-if="$root.enable_piwik_reload">
          <template v-if="index === breadcrumbData.length - 1">
            <span
              :class="{
                'router-link-exact-active cursor-link':
                  index === breadcrumbData.length - 1,
              }"
              v-if="data.type === 'custom'"
              >{{ data.title }}</span
            >
            <span
              v-else
              :class="{
                'router-link-exact-active cursor-link':
                  index === breadcrumbData.length - 1,
              }"
              >{{ data.title }}
            </span>
          </template>
          <template v-else>
            <a
              :title="data.title"
              :class="{
                'router-link-exact-active cursor-link':
                  index === breadcrumbData.length - 1,
              }"
              v-if="data.type === 'custom'"
              :href="data.url"
              >{{ data.title }}</a
            >
            <a
              :title="data.title"
              v-else
              :class="{
                'router-link-exact-active cursor-link':
                  index === breadcrumbData.length - 1,
              }"
              :href="getRouteLink(data.slug, data.type, data.base_slug)"
              >{{ data.title }}
            </a>
          </template>
        </template>
        <template v-else>
          <template v-if="index === breadcrumbData.length - 1">
            <span
              :class="{
                'router-link-exact-active cursor-link':
                  index === breadcrumbData.length - 1,
              }"
              v-if="data.type === 'custom'"
              >{{ data.title }}</span
            >
            <span
              v-else
              :class="{
                'router-link-exact-active cursor-link':
                  index === breadcrumbData.length - 1,
              }"
              >{{ data.title }}
            </span>
          </template>
          <template v-else>
            <a
              :title="data.title"
              :class="{
                'router-link-exact-active cursor-link':
                  index === breadcrumbData.length - 1,
              }"
              v-if="data.type === 'custom'"
              :href="data.url"
              >{{ data.title }}</a
            >
            <router-link
              :title="data.title"
              v-else
              :class="{
                'router-link-exact-active cursor-link':
                  index === breadcrumbData.length - 1,
              }"
              :to="getRouteLink(data.slug, data.type, data.base_slug)"
              >{{ data.title }}
            </router-link>
          </template>
        </template>
      </li>
    </ul>
    <span
      v-if="templateName && gameBlockTitle != ''"
      :class="{
        'span-h1 custom-font-1 cust-h1 game-span': true,
        'text-light': !getContrastYIQ($root.color_schema.footer_bg),
      }"
      >{{ gameBlockTitle }}</span
    >
  </div>
</template>

<script>
import {
  pSBC,
  hexToRgb,
  getContrastYIQ,
  getOffset,
} from "@/misc/misc-function";
export default {
  name: "Breadcrumb",
  props: ["breadcrumbData", "dark", "templateName", "gameBlockTitle"],
  methods: {
    getContrastYIQ,
  },
  mounted() {
    if (this.breadcrumbData) {
      localStorage.setItem(
        "storedbreadcrumbData",
        JSON.stringify(this.breadcrumbData)
      );
      if (this.breadcrumbData.length > 0) {
        let catNewsList = this.breadcrumbData.filter((ele) =>
          ele.hasOwnProperty("cat")
        );
        if (catNewsList.length > 0) {
          localStorage.setItem("storedData", catNewsList[0].cat);
          localStorage.setItem("storedPageName", catNewsList[0].slug);
        }
      }
    }
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.breadcrumbs {
  // padding: 10px 0;
  margin-bottom: 10px;
  @media (min-width: @sizes[small]) {
    margin-bottom: 20px;
  }
  ul {
    .display-flex();
    .align-items(center);
    .flex-wrap(wrap);
    @media (min-width: @sizes[small]) {
      .flex-wrap(nowrap);
    }
    li {
      font-weight: 300;
      font-size: 12px;
      font-family: var(--default-regular);
      line-height: 19px;
      color: @white;
      position: relative;
      padding-right: 16px;
      &:after {
        position: absolute;
        content: ">";
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
        color: @white;
        font-size: 12px;
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
      &:last-child {
        background: none;
        margin-right: 0;
        padding-right: 0;
      }
      a {
        color: @white;
        font-weight: 300;
        font-family: var(--default-regular);
        text-decoration: none;
        &:hover {
          color: @orange;
        }
      }
      &.active {
        color: @orange;
      }
      .router-link-exact-active {
        color: var(--primary-btn) !important;
      }
    }
  }
  &-invert {
    ul {
      li {
        color: @lightdark;
        &:after {
          color: @lightdark;
        }
        a {
          color: @lightdark;
          &:hover {
            color: @orange;
          }
        }
      }
    }
  }
  &-light {
    ul {
      li {
        color: rgba(255, 255, 255, 0.7) !important;
        &:after {
          color: rgba(255, 255, 255, 0.7) !important;
        }
        a {
          color: rgba(255, 255, 255, 0.7) !important;
          &:hover {
            color: var(--primary-btn) !important;
          }
        }
      }
    }
  }
  &-dark {
    ul {
      li {
        color: @gray-dimmer;
        &:after {
          color: @gray-dimmer;
        }
        a {
          color: @gray-dimmer;
          &:hover {
            color: var(--primary-btn) !important;
          }
        }
      }
    }
  }
}

.game-ul {
  @media (min-width: @sizes[large]) {
    width: 73%;
    //float: left;
  }
}

.game-span {
  width: 27%;
  float: left;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
  display: none;
  @media (min-width: @sizes[large]) {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/Breadcrumb.vue